import { render, staticRenderFns } from "./FormSchema.vue?vue&type=template&id=53bc8b31&scoped=true&"
import script from "./FormSchema.vue?vue&type=script&lang=js&"
export * from "./FormSchema.vue?vue&type=script&lang=js&"
import style0 from "./FormSchema.vue?vue&type=style&index=0&id=53bc8b31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc8b31",
  null
  
)

export default component.exports